import type { Toast } from "../../providers/ToastProvider";

interface ToastViewportProps {
  toasts: Toast[];
  onDismiss: (id: number) => void;
}

const KIND_CLASSES: Record<Toast["kind"], string> = {
  success: "bg-success-50 text-success-700 border-success-500",
  error: "bg-danger-50 text-danger-700 border-danger-500",
};

/** Fixed bottom-right stack of dismissable toasts. */
export function ToastViewport({ toasts, onDismiss }: ToastViewportProps) {
  if (toasts.length === 0) {
    return null;
  }
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-50 flex w-full max-w-sm flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role={toast.kind === "error" ? "alert" : "status"}
          className={[
            "pointer-events-auto flex items-start gap-3 rounded-md border px-4 py-3 text-body shadow-md",
            KIND_CLASSES[toast.kind],
          ].join(" ")}
        >
          <span className="flex-1">{toast.message}</span>
          <button
            type="button"
            aria-label="Dismiss"
            onClick={() => onDismiss(toast.id)}
            className="-mr-1 -mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded opacity-70 hover:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-current"
          >
            <svg viewBox="0 0 20 20" className="h-4 w-4" fill="currentColor" aria-hidden="true">
              <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
}
